import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Node.js, TypeScript, NestJS",
          "Integrations, Webhooks, Security",
          "PostgreSQL, MySQL, REST APIs",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 32,
        delay: 48,
      }}
    />
  );
}

export default Type;
